import { useTranslation } from 'react-i18next';

import { AccountDetails } from '@modules/accounts/types';

type Fields =
  | 'fullName'
  | 'recipient'
  | 'iban'
  | 'swiftCode'
  | 'countryOfResidence'
  | 'city'
  | 'address';

type UseAccountsFields = {
  [kei in Fields]: {
    caption: string;
    text: string;
  };
};

const useAccountsFields = (account: AccountDetails): UseAccountsFields => {
  const { t } = useTranslation();

  return {
    fullName: {
      caption: t('sepa.full_name'),
      text: `${account?.first_name_en} ${account?.last_name_en}`,
    },
    recipient: {
      caption: t('sepa.recipient'),
      text: `${account?.first_name_en} ${account?.last_name_en}`,
    },
    iban: {
      caption: t('public.iban'),
      text: account?.iban,
    },
    swiftCode: {
      caption: t('public.swift_code'),
      text: account?.swift,
    },
    countryOfResidence: {
      caption: t('public.country_of_residence'),
      text: account?.beneficiary_country,
    },
    city: {
      caption: t('public.city'),
      text: account?.beneficiary_city,
    },
    address: {
      caption: t('public.address'),
      text: account?.beneficiary_address_line,
    },
  };
};

export default useAccountsFields;
